export interface  FooterData {
  id: string;
  title: string;
  url: string;
  linkList: {
    label: string;
    url: string;
  }[];
}

export const jaList:FooterData[] = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckb.com/about/',
    linkList: [
      {
        label: '最新情報',
        url: 'https://www.theckb.com/news/'
      },
      {
        label: '费率计划',
        url: 'https://www.theckb.com/price/plan/'
      },
      {
        label: '计划诊断',
        url: 'https://www.theckb.com/price/diagnose/'
      },
      {
        label: '国际航运',
        url: 'https://www.theckb.com/price/shipping-fee/'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckb.com/merchandise/',
    linkList: [
      {
        label: '- 购买现有产品',
        url: 'https://www.theckb.com/merchandise/purchase/'
      },
      {
        label: '- OEM・ODM',
        url: 'https://www.theckb.com/merchandise/oemodm/'
      },
      {
        label: '- FBA直送',
        url: 'https://www.theckb.com/merchandise/fba/'
      }
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckb.com/inspection/',
    linkList: [
      {
        label: '- 检查',
        url: 'https://www.theckb.com/inspection/check/'
      },
      {
        label: '- 维修',
        url: 'https://www.theckb.com/inspection/repair/'
      }
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckb.com/logistics/',
    linkList: [
      {
        label: '- 国际运输',
        url: 'https://www.theckb.com/logistics/shipping/'
      },
      {
        label: '- 仓库储存',
        url: 'https://www.theckb.com/logistics/warehouse/'
      }
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckb.com/promotion/',
    linkList: [
      {
        label: '- 翻译',
        url: 'https://www.theckb.com/promotion/translate/'
      },
      {
        label: '- 照片',
        url: 'https://www.theckb.com/promotion/photo/'
      },
      {
        label: '- 导入文章',
        url: 'https://www.theckb.com/promotion/blog/'
      }
    ]
  },
  {
    id: '6',
    title: '系统',
    url: 'https://www.theckb.com/system/',
    linkList: [
      {
        label: '- 库存系统',
        url: 'https://s.theckb.com/b2b/index/ecommerce'
      },
      {
        label: '- 无库存系统',
        url: 'https://s.theckb.com/d2c/index/ecommerce'
      }
    ]
  },
  {
    id: '7',
    title: '使用流程',
    url: 'https://www.theckb.com/flow/',
    linkList: [
      {
        label: '常问问题',
        url: 'https://www.theckb.com/faq/'
      },
      {
        label: '文件要求',
        url: 'https://www.theckb.com/data/'
      },
      {
        label: '免费注册2',
        url: 'https://www.theckb.com/contact/'
      },
      {
        label: '询问',
        url: 'https://www.theckb.com/contact/'
      }
    ]
  }
]

export const koList:FooterData[] = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckbkorea.com/',
    linkList: [
      {
        label: '费率计划',
        url: 'https://www.theckbkorea.com/about-1-3'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckbkorea.com/blog',
    linkList: [
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckbkorea.com/about-1',
    linkList: [
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckbkorea.com/about-1-1',
    linkList: [
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckbkorea.com/about-1-2',
    linkList: [
    ]
  },
  {
    id: '6',
    title: '库存系统',
    url: 'https://s.theckb.com/ko/b2b/index/ecommerce',
    linkList: [
      {
        label: '无库存系统',
        url: 'https://s.theckb.com/ko/d2c/index/ecommerce'
      }
    ]
  }
]
export const enList:FooterData[] = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '最新情報',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '费率计划',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '计划诊断',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '国际航运',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 购买现有产品',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- OEM・ODM',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- FBA直送',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 检查',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 维修',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 国际运输',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 仓库储存',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 翻译',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 照片',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 导入文章',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '6',
    title: '系统',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 库存系统',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 无库存系统',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  }
]

export interface imgLinks {
  facebook: string;
  twitter:string;
  instagram?: string;
  tiktok: string;
  line?: string;
  youtube:string;
  kakao?:string;
  company:string;
}


export const jaSite:imgLinks={
  'facebook':'https://www.facebook.com/profile.php?id=100088353218048',
  'twitter':'https://twitter.com/Theckb_official',
  'instagram':'https://www.instagram.com/theckb_official/',
  'tiktok':'https://www.tiktok.com/@the_ckb',
  'line':'https://line.me/R/ti/p/@962puoaf?oat_content=url',
  'youtube':'https://www.youtube.com/@theckb2011',
  'company':'https://www.theckb.com/company/'
}

export const koSite:imgLinks={
  'facebook':'https://www.facebook.com/profile.php?id=100086914794478',
  'twitter':'https://twitter.com/k_theckb',
  'instagram':'https://www.instagram.com/korea_theckb/',
  'tiktok':'https://www.tiktok.com/@theckb_en?lang=en',
  'kakao':'https://pf.kakao.com/_uzWxoxj',
  'youtube':"https://youtube.com/@theckb_korea?si=Tx1acBa4UsUrFDtA",
  'company':'https://www.theckbkorea.com/%ED%9A%8C%EC%82%AC-%EC%A0%95%EB%B3%B4'
}

export const enSite:imgLinks={
  'facebook':'https://www.facebook.com/profile.php?id=100090941351148',
  'twitter':'https://twitter.com/TheCKB_us',
  'instagram':'https://www.instagram.com/theckb_en/?img_index=5',
  'tiktok':'https://www.tiktok.com/@theckb_en?lang=en',
  'youtube':'https://www.youtube.com/@theckb_en/videos',
  'company':'https://www.theckbofficial.com/about-9'
}